import { API_BASE_URL, API_BASE_URL_BASE } from "../config/api";

// El service worker vive en public/sw.js y no pasa por el bundler, así que no
// puede leer las variables de entorno. El origen de la API se le pasa en la URL
// de registro. De paso, cambiar de entorno cambia esa URL y eso obliga al
// navegador a reinstalar el worker, que es justo lo que queremos.
const urlDelWorker = () => {
  let api = "";
  try {
    api = new URL(API_BASE_URL_BASE || API_BASE_URL).origin;
  } catch (e) {
    api = "";
  }
  return `${process.env.PUBLIC_URL}/sw.js?api=${encodeURIComponent(api)}`;
};

export const registerServiceWorker = () => {
  if (!("serviceWorker" in navigator)) return;

  // En desarrollo el worker se saltaría el hot reload y serviría assets viejos.
  if (process.env.NODE_ENV !== "production") return;

  // Si PUBLIC_URL apunta a otro origen (CDN), el worker no tendría alcance sobre
  // la página y el registro fallaría silenciosamente.
  const publicUrl = new URL(process.env.PUBLIC_URL || "", window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register(urlDelWorker()).catch((error) => {
      console.error("No se pudo registrar el service worker:", error);
    });
  });
};
